<num-save-file-modal (save)="downloadCRTDL($event)" (cancel)="doDiscard()">
  <h2>
    {{ 'DATAQUERY.DATASELECTION.SAVE.HEADER' | translate }}
  </h2>
</num-save-file-modal>
